import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProductForm } from "../../data/entities";
import { ProductForm } from "../components/form";
import { productRedux } from "../state/state";

export const ProductCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IProductForm): Promise<void> => {
    await dispatch(productRedux.actions.create(values));
    history.push(ROUTES.product);
  };

  const createProductBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.product.create);

  return <ProductForm branch={createProductBranch} onSubmit={onSubmit} initialData={null} submitTitle="Create" />;
};
